import { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { ZIndex } from 'shared/constants/zIndex'
import {
  CallSection,
  type ICallSectionActionsTitleProps,
} from 'widgets/CallPopUp/ui/CallSection/CallSection'
import { CallList } from 'widgets/CallPopUp/ui/CallList/CallList'
import { useCallPopUpDefaultContext } from 'widgets/CallPopUp/context/callPopUpDefaultContext'

export const CallConferencePopUpContent = observer(() => {
  const store = useCallPopUpDefaultContext()
  const {
    inboxesList,
    reactionContactsSearch,
    contactsLoading,
    inboxesLoading,
    search,
    handleSearch,
    clearSearch,
    contactsList,
    handleAddParticipant,
    isConferenceParticipants,
    isConferenceParticipantsLoading,
    participants,
    handleChangeConferenceParticipantsStatus,
    checkParticipantsLimit,
    isValidNumber,
    resetConference,
  } = store
  const loading = contactsLoading || inboxesLoading

  useEffect(() => {
    reactionContactsSearch()

    return () => {
      resetConference()
    }
  }, [])

  useEffect(() => {
    if (isConferenceParticipants) {
      clearSearch()
    }
  }, [isConferenceParticipants])

  if (isConferenceParticipants) {
    return (
      <CallSection
        title={'Conference'}
        actions={[
          {
            label: 'Add',
            icon: 'add',
            disabled: checkParticipantsLimit || isConferenceParticipantsLoading,
            tooltipProps: {
              zIndex: ZIndex.OVERLAY_TOP_1,
              placement: 'top-end',
              label: checkParticipantsLimit ? 'Conference capacity reached' : '',
            },
            onChange: () => {
              handleChangeConferenceParticipantsStatus(false)
            },
          },
        ]}
      >
        <CallList
          isSearch={false}
          itemsGroups={[
            {
              name: '',
              items: participants,
            },
          ]}
          isValidNumber={isValidNumber}
          isTransfer={false}
        />
      </CallSection>
    )
  }

  const actionsTitle: ICallSectionActionsTitleProps[] = []

  if (participants.length > 1) {
    actionsTitle.push({
      icon: 'chevronLeft',
      onChange: () => {
        handleChangeConferenceParticipantsStatus(true)
      },
    })
  }

  return (
    <CallSection title={'Add to call'} actionsTitle={actionsTitle}>
      <CallList
        placeholder={'Search inbox, contact or dial a number'}
        itemsGroups={[
          {
            name: 'Inboxes',
            items: inboxesList,
          },
          {
            name: 'Contacts',
            items: contactsList,
          },
        ]}
        searchValue={search}
        onChangeSearch={handleSearch}
        loading={loading}
        onChangeItem={handleAddParticipant}
        isValidNumber={isValidNumber}
        isTransfer={false}
      />
    </CallSection>
  )
})
